module.exports = "/assets/packs/images/7077d4bd6cc54298cc352373b0ab9118.png";